import { Component, Input } from '@angular/core';
import { BooleanPipe } from '../../pipes/boolean.pipe';

@Component({
  selector: 'app-boolean',
  imports: [BooleanPipe],
  templateUrl: './boolean.component.html',
  styleUrls: ['./boolean.component.scss'],
})
export class BooleanComponent {
  @Input() public value!: boolean;
}
